/* eslint-disable no-debugger */
/* eslint-disable no-console */
import 'whatwg-fetch'; // fetch polyfill

const calibremindidentify = () => {
	const formList = document.getElementsByTagName('form');
	let scriptRun = true;
	let j = 0;

	const validateEmail = (email) => {
		/* eslint-disable-next-line no-useless-escape */
		const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
		if (reg.test(email) === false) {
			return false;
		}
		return true;
	};

	const findEmailFields = (currentForm) => {
		let currentField = '';
		let email = '';
		// console.log(currentForm);

		if (currentForm.elements.length > 0) {
			for (j; j < currentForm.elements.length; j += 1) {
				currentField = currentForm.elements[j];
				if (currentField.type === 'email' || currentField.name === 'email') {
					// console.log('Email field found');
					if (currentField.value !== '') {
						// console.log(`Email: ${currentField.value}`);
						// begin custom CaliberMind identify code
						if (typeof analytics === 'undefined') {
							console.log('[calibermind] Identify not called - analytics core library missing from global window object');
						} else {
							try {
								const emailInput = currentField;
								if (emailInput && emailInput.value) {
									email = emailInput.value;
									if (validateEmail(email) && scriptRun) {
										/* eslint-disable-next-line no-undef */
										analytics.identify(email, { email });
										scriptRun = false;
										console.log('Calibremind identify called');
									}
								}
							} catch (error) {
								console.error(error);
							}
						}
						// end custom CaliberMind identify code
					}
				}
			}
		}
	};

	if (formList.length) {
		formList.forEach((item) => {
			// console.log(`${formList.length} form(s) found`);
			/* eslint-disable-next-line no-loop-func */
			item.addEventListener('submit', () => {
				findEmailFields(item);
			});
		});
	}
};

export default calibremindidentify;

/* eslint-enable no-console */
/* eslint-enable no-debugger */
